module.exports = __webpack_public_path__ + "static/media/england_PNG723.9dc44787.png";